import React from 'react';

/**
 * @constant {Object} BEAUTIFY_OPTIONS the options to pass to cssbeautify
 */
export var BEAUTIFY_OPTIONS = {
  autosemicolon: true,
  indent: '  '
};

/**
 * @constant {boolean} IS_PRODUCTION is the runtime in the production environment
 */
export var IS_PRODUCTION = !!(process && process.env && process.env.NODE_ENV === 'production');

var _React$version$split$ = React.version.split('.').slice(0, 2).map(Number),
    REACT_MAJOR_VERSION = _React$version$split$[0],
    REACT_MINOR_VERSION = _React$version$split$[1];

/**
 * @constant {boolean} HAS_UNSAFE_METHODS have lifecycle methods been prefixed with `UNSAFE_` in the React version
 */


export var HAS_UNSAFE_METHODS = REACT_MAJOR_VERSION >= 16 && REACT_MINOR_VERSION >= 3;